<template>
<div class="chapter">
<div class="inner_page">
<div id="OldFlames_epub-5.html" xml:lang="en-US">
<div class="story">
<p class="CT-new-page"><span class="Section-Symbol char-style-override-14">A</span><span class="char-style-override-14">cknowledgements</span></p>
<p class="BT-1st-Para para-style-override-10">To <span class="char-style-override-15">Daniel Edelman</span> of Ridgefield, Connecticut, who put a roof over my head while I wrote chunks of this.</p>
<p class="BT-1st-Para para-style-override-10">To <span class="char-style-override-15">Arthur Cantor</span>, who did the same in Manhattan.</p>
<p class="BT-1st-Para para-style-override-10">To <span class="char-style-override-15">Sarah Teale</span>, who got between me and the phone and the fax for the best part of four months.</p>
<p class="BT-1st-Para para-style-override-10">To <span class="char-style-override-15">Art Tatum</span>, who in 1956, the last year of his life, recorded session after session of his finest work, and kept me intrigued and listening forty years on.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OldFlames_epub5.vue?99026316